"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forwardRefWithStatics = forwardRefWithStatics;
var _react = require("react");
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
function forwardRefWithStatics(component, statics) {
  return (0, _hoistNonReactStatics.default)( /*#__PURE__*/(0, _react.forwardRef)(component), statics);
}